import React, { useState, createContext } from 'react';

const defaultModalContext = {
  modalContent: null, // Default content is null
  openModalWithContent: content => {
    return content;
  }, // We use this dummy function to initialize the context
  isModalOpen: false, // Add this
  closeModal: () => {}, // Add this
};
export const ModalContext = createContext(defaultModalContext);

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModalWithContent = content => {
    setModalContent(content);
    setModalOpen(true); // Make sure to set this to true
  };
  const closeModal = () => setModalOpen(false);

  return (
    <ModalContext.Provider value={{ modalContent, openModalWithContent, isModalOpen, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
